import React from 'react';
import {Anchor, Flexbox, Label} from "../../../common/fusion-ui";
import {useTheme} from "../../../common/ProjectThemeProvider";

const AuthFooter = React.memo(({}) => {
    const theme = useTheme();


    return (<>
        <div className={'w-100 m-0 p-0 py-0 px-2 bg-dangerx position-fixedx'}
             style={{bottom: '0rem', backgroundColor: theme.primary20}}>
            <Flexbox className={'w-100'}
                     alignAt={'center'} alignAtSm={'start'}
                     justifyAt={'between'}
                     wrap={'wrap'}>

                {/*start*/}
                <Label className={'m-0 p-0 px-1 fss-normal text-nowrap'} color={theme.text}>
                    {`© ${new Date().getFullYear()} KOLs and Peers. All rights reserved.`}
                </Label>

                {/*middle*/}
                <Flexbox className={''}
                         alignAt={'center'}
                         justifyAt={'center'}>
                    <Anchor className={'m-0 p-0 fss-normal mx-2 text-nowrap'}
                            href={`https://www.kolsandpeers.com/privacy_policy.php`}
                            target={'_blank'}
                            simple={true}>
                        Privacy Policy
                    </Anchor>
                    <span style={{borderRight: `1.5px solid ${theme.text}`, height: '13px'}}></span>
                    <Anchor className={'m-0 p-0 fss-normal mx-2 text-nowrap'}
                            href={`https://www.kolsandpeers.com/terms_of_use.php`}
                            target={'_blank'}
                            simple={true}>
                        Terms of Use
                    </Anchor>
                </Flexbox>

                {/*end*/}
                <Anchor className={'m-0 p-0 fss-normal ps-2 pe-1 text-nowrap'}
                        href={`mailto:solutions@kolsandpeers.com`}
                        simple={true}>
                    {`solutions@kolsandpeers.com`}
                </Anchor>
            </Flexbox>
        </div>
    </>);
});

export default AuthFooter;
